module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav'), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between align-start ",
    staticStyle: {
      "background": "#eef1fa",
      "padding": "30px 0",
      "min-height": "600px"
    }
  }, [(_vm.detail) ? _c('div', {
    staticClass: "marginauto animated fadeInUp",
    staticStyle: {
      "width": "1145px"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "945px",
      "padding": "20px 100px 50px 100px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "sd_title"
  }, [_c('p', {
    staticClass: "biaoti1"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), (_vm.type == 0) ? _c('p', {
    staticClass: "bt_mes"
  }, [_vm._v("\n                        " + _vm._s(_vm.detail.small_title) + " " + _vm._s(_vm.detail.small_title1) + "\n                    ")]) : _c('p', {
    staticClass: "bt_mes"
  }, [_vm._v("\n                        发布时间：" + _vm._s(_vm.detail.release_time) + " \n                    ")])]), _vm._v(" "), (_vm.type == 0) ? _c('div', {
    staticClass: "sd_content padding-top"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), (_vm.detail.file_href.length) ? _c('div', {
    staticClass: "flex justify-start align-start flex-direction"
  }, _vm._l((_vm.detail.file_href), function(item, index) {
    return _c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard",
        value: (item.file_href),
        expression: "item.file_href"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.clipboardSuccessHandler),
        expression: "clipboardSuccessHandler",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.clipboardErrorHandler),
        expression: "clipboardErrorHandler",
        arg: "error"
      }],
      key: index,
      staticClass: "pointer filecolor"
    }, [_c('span', {
      staticStyle: {
        "color": "#909399"
      }
    }, [_vm._v(_vm._s(item.file_name))]), _c('el-tag', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "size": "mini",
        "effect": "dark"
      }
    }, [_vm._v("点击复制网址在新标签页打开")])], 1)
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "sd_content padding-top"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b71ac11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/policydetail.vue
// module id = 391
// module chunks = 1